import React, { useEffect, useState, useRef } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './msalConfig';
import { AuthProvider } from './authContext';
import { OpenRouterProvider } from './context/OpenRouterContext';
import AppRoutes from './routes/AppRoutes';
import AlertsCustom from './components/Alerts';
import MaintenancePage from './pages/Maintenance';
import './global.css';

const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE;
console.log("Maintenance mode:", isMaintenanceMode);

function App() {

  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("error");
  const [alertTitle, setAlertTitle] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const sessionExpiredHandled = useRef(false);

  useEffect(() => {
    const handleSessionExpired = () => {
      if (sessionExpiredHandled.current) return;
      sessionExpiredHandled.current = true;

      setAlertType("warning");
      setAlertTitle("session expired");
      setAlertMessage(
        "Your session has expired or is no longer valid. The page will be reloaded."
      );
      setShowAlert(true);

      setTimeout(() => {
        window.location.reload();
      }, 2500);
    };

    window.addEventListener("session-expired", handleSessionExpired);

    return () => {
      window.removeEventListener("session-expired", handleSessionExpired);
    };
  }, []);

  if (isMaintenanceMode=="true") {
    return <MaintenancePage />;
  }

  return (
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <OpenRouterProvider>
          <Router>
            <AppRoutes />
            {showAlert && (
              <AlertsCustom
                type={alertType}
                title={alertTitle}
                message={alertMessage}
                onClose={() => setShowAlert(false)}
              />
            )}
          </Router>
        </OpenRouterProvider>
      </AuthProvider>
    </MsalProvider>
  );
}

export default App;
